module.exports = __webpack_public_path__ + "img/textalign-left.8811233b.svg";